import type { INoteAttribute } from './NoteAttribute.interface';

export default class NoteAttribute implements INoteAttribute {
  name: string;
  value: string;

  getName() {
    return this.name;
  }

  static build = (data: INoteAttribute) => new NoteAttribute(data);
  static blank = () => new NoteAttribute();

  /**
   * Constructor
   * @param {INoteAttribute} data
   */
  constructor(data?: INoteAttribute) {
    this.name = data?.name || '';
    this.value = data?.value || '';
  }
}
